import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ShieldCheck, XCircle, Loader2, Crown } from "lucide-react";
import { api } from "../lib/api";

const LOGO_URL = "https://customer-assets-eiarnc6j.emergentagent.net/job_b2b-intelligence-2/artifacts/08rr2gpw_file_0000000021d08208bdb939d8b8dd4a57.png";

export default function VerifyMember() {
  const { memberId } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/verify/${memberId}`).then((r) => setData(r.data)).catch(() => setNotFound(true));
  }, [memberId]);

  const active = data && ["ACTIVE MEMBER", "APPROVED"].includes(data.membership_status);

  return (
    <div className="max-w-lg mx-auto px-4 py-16 md:py-24" data-testid="verify-page">
      <div className="text-center mb-8">
        <img src={LOGO_URL} alt="10XGLOBAL" className="h-14 w-auto mx-auto rounded-sm bg-white px-1.5 py-0.5" />
        <p className="text-[10px] font-mono uppercase tracking-[0.35em] text-slate-500 mt-4">Membership Verification</p>
      </div>

      {!data && !notFound && (
        <div className="card-surface p-10 flex justify-center text-slate-500" data-testid="verify-loading"><Loader2 size={18} className="animate-spin" /></div>
      )}

      {notFound && (
        <div className="card-surface p-8 text-center" data-testid="verify-not-found">
          <XCircle size={40} className="text-red-400 mx-auto mb-4" />
          <p className="font-display text-lg font-bold text-slate-100">CERTIFICATE NOT VERIFIED</p>
          <p className="text-sm text-slate-400 mt-2">No member found for ID <span className="font-mono text-slate-200">{memberId}</span>. Check the ID on the certificate and try again.</p>
          <Link to="/contact" className="btn-outline mt-6 inline-flex" data-testid="verify-contact-btn">CONTACT SUPPORT</Link>
        </div>
      )}

      {data && (
        <div className="card-surface hairline-gold p-8" data-testid="verify-result">
          <div className="text-center">
            <span className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-[11px] font-mono uppercase tracking-widest ${active ? "border-emerald-500/50 bg-emerald-500/10 text-emerald-300" : "border-amber-500/50 bg-amber-500/10 text-amber-300"}`} data-testid="verify-status-pill">
              <ShieldCheck size={13} /> {active ? "Verified Active Member" : `Status: ${data.membership_status}`}
            </span>
            <p className="mt-5 font-display text-2xl font-black text-slate-100" data-testid="verify-company">{(data.company || data.name || "").toUpperCase()}</p>
            <p className="text-sm text-slate-400 mt-1" data-testid="verify-name">{data.name}</p>
          </div>
          <div className="mt-7 space-y-3 text-sm">
            {[
              ["Member ID", data.member_id, "verify-member-id"],
              ["Membership Plan", data.plan, "verify-plan"],
              ["Verification Level", data.verification_level, "verify-level"],
              ["Member Since", data.member_since || "—", "verify-since"],
              ["Valid Till", data.valid_till || "—", "verify-valid-till"],
            ].map(([k, v, tid]) => (
              <div key={k} className="flex justify-between gap-4 border-b border-slate-800 pb-3">
                <span className="text-[10px] font-mono uppercase tracking-widest text-slate-500">{k}</span>
                <span className="font-semibold text-slate-100 font-mono text-[13px]" data-testid={tid}>{v}</span>
              </div>
            ))}
          </div>
          <p className="mt-6 flex items-center justify-center gap-1.5 text-[11px] text-slate-600 font-mono"><Crown size={12} className="text-gold" /> Official record — 10XGLOBAL Advisory · www.10x-global.com</p>
        </div>
      )}
    </div>
  );
}
